import React from 'react';
import PropTypes from 'prop-types';

const ContentSection = ({
  children,
  className = '',
  contentClassName = '',
}) => {
  return (
    <section
      className={`flex justify-center items-center bg-white md:bg-transparent px-0 md:px-25 md:pb-15 ${className}`}
    >
      <div
        className={`bg-white z-10 inline-block px-6 py-12 md:px-12 md:py-15 md:rounded-xl md:shadow-lg text-center md:-mt-10 mx-auto w-full md:w-auto ${contentClassName}`}
      >
        {children}
      </div>
    </section>
  );
};

ContentSection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
};

export default ContentSection;
